var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0a1 1 0 0 0-1 1v14a1 1 0 0 0 2 0V1a1 1 0 0 0-1-1zm19 7.995c0-.339-.11-.624-.332-.857a1.082 1.082 0 0 0-.816-.349H9.895l1.663-1.767c.213-.223.323-.501.33-.833a1.16 1.16 0 0 0-.33-.853A1.062 1.062 0 0 0 10.755 3c-.322 0-.59.112-.803.336l-3.626 3.81a1.12 1.12 0 0 0-.248.394A1.332 1.332 0 0 0 6 7.995c0 .158.026.31.078.454.052.145.135.277.248.395l3.626 3.81c.214.224.478.339.794.346a1.05 1.05 0 0 0 .812-.346c.213-.224.32-.505.32-.844 0-.338-.107-.619-.32-.843L9.895 9.2h8.957c.322 0 .594-.116.816-.349.221-.232.332-.518.332-.856z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavCollapse);
export default __webpack_public_path__ + "static/media/nav-collapse.51a50c0714c9cdc451e10e7af2e18101.svg";
export { ForwardRef as ReactComponent };